import { t } from '@lingui/core/macro';
import { Container, StyledLoader } from './styled';
export function PageLoader() {
    return (<Container role="status">
      <StyledLoader size={16} label={t `Loading`}/>
    </Container>);
}
